var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8378 6.75703L16.1198 5.03906L7.61904 13.5375L7.25342 15.6234L9.33701 15.2555L17.8378 6.75703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6245 19.5938H3.37451C2.95967 19.5938 2.62451 19.9289 2.62451 20.3438V21.1875C2.62451 21.2906 2.70889 21.375 2.81201 21.375H21.187C21.2901 21.375 21.3745 21.2906 21.3745 21.1875V20.3438C21.3745 19.9289 21.0394 19.5938 20.6245 19.5938ZM6.03936 17.625C6.08623 17.625 6.13311 17.6203 6.17998 17.6133L10.1222 16.9219C10.169 16.9125 10.2136 16.8914 10.2464 16.8563L20.1815 6.92109C20.2033 6.89941 20.2205 6.87366 20.2323 6.8453C20.244 6.81695 20.2501 6.78656 20.2501 6.75586C20.2501 6.72516 20.244 6.69477 20.2323 6.66642C20.2205 6.63806 20.2033 6.61231 20.1815 6.59063L16.2862 2.69297C16.2417 2.64844 16.1831 2.625 16.1198 2.625C16.0565 2.625 15.9979 2.64844 15.9534 2.69297L6.01826 12.6281C5.98311 12.6633 5.96201 12.7055 5.95264 12.7523L5.26123 16.6945C5.23843 16.8201 5.24658 16.9493 5.28497 17.071C5.32335 17.1927 5.39083 17.3032 5.48154 17.393C5.63623 17.543 5.83076 17.625 6.03936 17.625V17.625ZM7.61904 13.5375L16.1198 5.03906L17.8378 6.75703L9.33701 15.2555L7.25342 15.6234L7.61904 13.5375V13.5375Z",
    fill: "#2D2B32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.880f0734474ec21bf477a7d4e35566ac.svg";
export { ForwardRef as ReactComponent };